import { useContext } from "react";
import {sharedDataContext} from '../redux/context/languageAndServerProvider'


const useLanguageAndServerData = () => {
    return useContext(sharedDataContext);
}

export default useLanguageAndServerData;